module.exports = __webpack_public_path__ + "img/Mission.db9aaeef.png";